export const GET_THERMOBOXES_REPORTS = 'thermoboxes-reports/GET_THERMOBOXES_REPORTS';
export const getThermoboxesReportsAction = payload => ({
	type: GET_THERMOBOXES_REPORTS,
	payload,
});

export const SET_THERMOBOXES_REPORTS = 'thermoboxes-reports/SET_THERMOBOXES_REPORTS';
export const setThermoboxesReportsAction = payload => ({
	type: SET_THERMOBOXES_REPORTS,
	payload,
});

export const SET_IS_THERMOBOXES_REPORTS_LOADING = 'thermoboxes-reports/SET_IS_THERMOBOXES_REPORTS_LOADING';
export const setIsThermoboxesReportsLoadingAction = payload => ({
	type: SET_IS_THERMOBOXES_REPORTS_LOADING,
	payload,
});

export const GET_THERMOBOXES = 'thermoboxes-reports/GET_THERMOBOXES';
export const getThermoboxesAction = () => ({
	type: GET_THERMOBOXES,
});

export const SET_THERMOBOXES = 'thermoboxes-reports/SET_THERMOBOXES';
export const setThermoboxesAction = payload => ({
	type: SET_THERMOBOXES,
	payload,
});

export const SET_IS_THERMOBOXES_LOADING = 'thermoboxes-reports/SET_IS_THERMOBOXES_LOADING';
export const setIsThermoboxesLoadingAction = payload => ({
	type: SET_IS_THERMOBOXES_LOADING,
	payload,
});

export const GET_MODES = 'thermoboxes-reports/GET_MODES';
export const getModesAction = () => ({
	type: GET_MODES,
});

export const SET_MODES = 'thermoboxes-reports/SET_MODES';
export const setModesAction = payload => ({
	type: SET_MODES,
	payload,
});

export const SET_IS_MODES_LOADING = 'thermoboxes-reports/SET_IS_MODES_LOADING';
export const setIsModesLoadingAction = payload => ({
	type: SET_IS_MODES_LOADING,
	payload,
});

export const SET_PAGINATION = 'thermoboxes-reports/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const RESET_STATE = 'thermoboxes-reports/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
